import { Button, colors, darkThemeSelector, EmptyState, styled } from '@meterup/atto';

import { paths } from '../constants';
import { makeLink } from '../utils/main_and_drawer_navigation';

const NotFoundPosition = styled('div', {
  display: 'flex',
  width: '100vw',
  maxWidth: '$520',
  padding: '$20',
});

const NotFoundContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100vw',
  height: '100dvh',
  padding: 0,
  backgroundColor: colors.bgApplicationLight,

  [darkThemeSelector]: {
    backgroundColor: colors.bgApplicationDark,
  },
});

export default function NotFound() {
  return (
    <NotFoundContainer>
      <NotFoundPosition>
        <EmptyState
          icon="attention"
          heading="Page not found"
          action={
            <Button
              as="a"
              href={makeLink(paths.pages.RootPage, {})}
              arrangement="leading-icon"
              icon="home"
            >
              Back to the Meter Dashboard
            </Button>
          }
        />
      </NotFoundPosition>
    </NotFoundContainer>
  );
}
